import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./DLPdf.css";   // 👈 NEW CSS

export default function DLPdf() {

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const [dlno, setDlno] = useState("");
  const [dob, setDob] = useState("");
  const [cardtype, setCardType] = useState("2");
  const [loading, setLoading] = useState(false);

  const submit = async () => {

    if (!dlno || !dob) {
      Swal.fire("Fill DL Number & DOB");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://rcfinder.online/api/dl_process.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: user.id,
          dlno,
          dob,
          cardtype
        })
      });

      const data = await res.json();
      console.log(data);

      if (data.status === "wallet_low") {
        Swal.fire("Wallet Low", "Please Recharge", "warning");
      }
      else if (data.status === "failed") {
        Swal.fire("Failed", data.message || "DL Failed", "error");
      }
      else if (data.status === "success") {
        Swal.fire("Success", "DL PDF Generated 🎉", "success");
        navigate("/dashboard/dlpdflist");
      }

    } catch (e) {
      Swal.fire("Server Error", "", "error");
    }

    setLoading(false);
  };

  return (
    <div className="dl-wrapper">

      {/* ===== Loading Overlay ===== */}
      {loading && (
        <div className="dl-loading">
          <div className="dl-load-box">
            <div className="dl-spinner"></div>
            <p className="dl-load-text">Processing DL Request...</p>
          </div>
        </div>
      )}

      <h2 className="dl-title">DL Instant PDF</h2>

      <div className="dl-price-box">
        DL PDF Charge: ₹149 / Search
      </div>

      <div className="dl-form">

        <input
          type="text"
          placeholder="Enter DL Number"
          value={dlno}
          onChange={(e) => setDlno(e.target.value.toUpperCase())}
          className="dl-input"
        />

        <input
          type="text"
          placeholder="DD-MM-YYYY"
          value={dob}
          onChange={(e) => setDob(e.target.value)}
          className="dl-input"
        />

        <select
          value={cardtype}
          onChange={(e) => setCardType(e.target.value)}
          className="dl-input"
        >
          <option value="1">White Background</option>
          <option value="2">Light Blue Background</option>
        </select>

        <button className="dl-btn" onClick={submit}>
          {loading ? "Processing..." : "Get DL PDF (₹149)"}
        </button>

      </div>
    </div>
  );
}
